import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// MUI imports
import { AppBar, Box, Drawer, IconButton, Toolbar, Grid2 } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
// styles imports
import styles from "./Admin.module.scss";
// local import
import { NavBar } from "./AdminComponents/Navbar";
import { Sidebar } from "./AdminComponents/Sidebar";
import { Actions } from "../../redux/constants/actionTypes";
import { getStore } from "../../Utils/storeUtils";
import { useSelector } from "react-redux";
import Alert from "../../GlobalComponents/Alert/Alert";
import { useMakeApiCalls } from "../../Hooks/useMakeApiCalls";
import { formatDate } from "../../Utils/utils";

export default function Admin({
  component: PageComponent,
  onOrganizationClick,
  ...rest
}) {
  // Accepting the callback
  const drawerWidth = 282;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [search, setSearch] = useState(false);
  const [value, setValue] = useState("");

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );

  const userDetails = useSelector((state) => state.users?.userDetails);

  const plansInfo = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans
  );

  const basePlan = plansInfo?.find((item) => item.basePlan === true);
  const nextPaymentDate = formatDate(basePlan?.expirationDate);
  const cancel = basePlan?.cancel;
  const daysBeforeExipry = basePlan?.daysBeforeExipry;
  const daysAfterExpiry = basePlan?.daysAfterExpiry;
  const basePlanOvergauge = basePlan?.planOvergauge;

  const paymentLinkCF = useSelector(
    (state) => state.sitesInfo?.overgauge?.paymentLink
  );

  const daysExpiry = basePlan?.daysAfterExpiry;
  const orgId = parseInt(params.orgId);
  const siteId = parseInt(params.siteId);

  const modifyPlan = location?.pathname.includes("/modify-plan");

  useEffect(() => {
    if (basePlanOvergauge) {
      getStore().dispatch({
        type: Actions.API_FETCH_PLAN_OVERGAUGE,
        data: {
          orgId: orgId,
        },
        meta: {
          onSuccess: () => {},
          onError: () => {},
        },
      });
    }
  }, [basePlanOvergauge, orgId]);

  useEffect(() => {
    if (orgId) {
      if (orgId === -1) {
        //
      } else if (!selectedOrg) {
        // api call for org
        // if error redirect to organization overview
        // if true set to selected org
        getStore().dispatch({
          type: Actions.API_SELECTED_ORG,
          orgId: orgId,
          meta: {
            onSuccess: () => {
              // if (params?.sitename) {
              //   getStore().dispatch({
              //     type: Actions.API_GET_SELECTED_SITE_DETAILS,
              //     data: { siteId: siteId },
              //   });
              // }
            },
            onError: () => {
              navigate("/account/organizations-overview");
            },
          },
        });
      } else if (selectedOrg?.orgId !== orgId) {
        // api call for org
        // if error redirect to organization overview
        // if true set to selected org
        getStore().dispatch({
          type: Actions.API_SELECTED_ORG,
          orgId: orgId,
          meta: {
            onSuccess: () => {
              if (params?.sitename) {
                getStore().dispatch({
                  type: Actions.API_GET_SELECTED_SITE_DETAILS,
                  data: { siteId: siteId },
                });
              }
            },
            onError: () => {
              navigate("/account/organizations-overview");
            },
          },
        });
      }
    } else {
      //redirect to organization overview
      navigate("/account/organizations-overview");
    }
  });

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="nav"
        className={styles.SidebarMobile}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          className={styles.DrawerContainerMobile}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRight: "0px solid rgba(0, 0, 0, 0.12)",
              background: "black",
            },
          }}
        >
          <Sidebar onMySpaceClick={onOrganizationClick} />
        </Drawer>
        <Drawer
          variant="permanent"
          className={styles.DrawerContainerWeb}
          open
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRight: "0px solid rgba(0, 0, 0, 0.12)",
              background: "black",
            },
          }}
        >
          <Sidebar onMySpaceClick={onOrganizationClick} />
        </Drawer>
      </Box>
      <AppBar className={styles.CustomAppBar}>
        <Toolbar className={styles.Toolbar}>
          <IconButton
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            className={styles.MenuButton}
          >
            <MenuIcon />
          </IconButton>
          <Grid2>
            <NavBar
              showLogo={false}
              showLogout={false}
              search={search}
              setSearch={setSearch}
              value={value}
              setValue={setValue}
            />
          </Grid2>
        </Toolbar>
      </AppBar>
      <Box component="main" className={styles.Inputcontainer}>
        <Toolbar className={styles.ToolbarLogo} />
        {cancel === true && daysBeforeExipry <= 6 && !modifyPlan && (
          <Alert
            header={
              selectedOrg?.parentOrgName !== null && orgId !== -1
                ? "Your primary organization's plan is scheduled for cancellation."
                : daysAfterExpiry > 0
                ? "Your plan has expired."
                : "Your plan is scheduled for cancellation."
            }
            subHeader={
              selectedOrg?.parentOrgName !== null && orgId !== -1
                ? "Your access will be affected once the primary organization's plan expires. Please contact your administrator for renewal."
                : daysAfterExpiry > 0
                ? "Renew now to continue using all services without interruption."
                : `Your plan will expire on ${nextPaymentDate}. You can renew anytime before it to avoid service interruption.`
            }
            button={
              selectedOrg?.parentOrgName !== null && orgId !== -1
                ? ""
                : "Renew Your Plan"
            }
            onClick={() => {
              navigate(`/account/${orgId}/modify-plan`);
            }}
          />
        )}
        {!modifyPlan && basePlanOvergauge && (
          <Alert
            header={`${selectedOrg?.name || userDetails?.userName}`}
            subHeader={
              selectedOrg?.country === "India" ||
              userDetails?.country === "India"
                ? "has exceeded the limits of a usage metric in your current plan. To avoid service disruption and continue without inconvenience, please"
                : "Your plan has exceeded its usage limits. Additional charges will be included in your next billing cycle."
            }
            button={
              (selectedOrg?.country === "India" ||
                userDetails?.country === "India") &&
              paymentLinkCF
                ? "Upgrade Now"
                : ""
            }
            onClick={() => {
              if (
                (selectedOrg?.country === "India" ||
                  userDetails?.country === "India") &&
                paymentLinkCF
              ) {
                window.open(paymentLinkCF, "_blank");
              }
            }}
          />
        )}
        <PageComponent searchValue={value} setSearch={setSearch} />
      </Box>
    </Box>
  );
}
